import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import {useAuthState} from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import styled from 'styled-components';
import Spinner from 'react-spinkit';

import './App.css';


import Home from './home';
import Login from './components/Login';
import AppCompiler from './components/AppCompiler';


// import ChatAI from './components/ai';
// import Login from '../containers/Login'
// import RecoveryPassword from '../containers/RecoveryPassword'
// import NotFound from '../pages/NotFound'

const App = () => {
  const [user,loading] = useAuthState(auth);

  if(loading){
    return(
      <AppLoading>
        <AppLoadingContent>
        <img src="https://seekicon.com/free-icon-download/slack_4.svg" alt=""/>
        <Spinner name="ball-pulse-rise"
       color="orange"fadeIn="none"/>
        </AppLoadingContent>
      </AppLoading>
    )
  }
  return (
    <Router>
      {!user ? (
        <Login/>
      ):(
        <>
       
        <Routes>
      
          <Route exact index path="/" element={<Home/>}/>
          <Route  path="/compiler" element={<AppCompiler/>}/>
     
          {/* <Route exact path="/login" element={<Login/>}/>
          <Route exact path="/recovery-password" element={<RecoveryPassword/>}/>
          <Route path="*" element={<NotFound/>}/> */}
        </Routes>
      </>
      )}
     
    </Router>
  );
}

export default App;

const AppLoading= styled.div`
display: flex;
justify-content: center;
align-items: center;
margin-top: 250px;

`;

const AppLoadingContent= styled.div`
  text-align: center;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  

  >img{
    height: 100px;
    padding: 20px;
    margin-bottom: 40px;
  }
`;
